<template>
    <div>
        <div class="row">
            <div class="col-12 col-lg-6 col-xl-4">
                <assessment-details :assessment="assessment"/>
                <assessment-address :assessment="assessment"/>
            </div>
            <div class="col-12 col-lg-6 col-xl-4">
                <df-coach :data="coach"/>
            </div>
            <div class="col-12 col-xl-4"><assessment-progress :assessment="assessment"/></div>
        </div>
    </div>
</template>

<script>
    import Assessment from '../../../models/Assessment';
    import AssessmentProgress from './summary/Progress';
    import AssessmentDetails from './summary/Details';
    import AssessmentAddress from './summary/Address';

    export default {
        components: { AssessmentProgress, AssessmentDetails, AssessmentAddress },

        props: {
            assessment: Assessment,
        },

        asyncComputed: {
            coach: async vm => (await vm.assessment.getCustomer()).getCoach(),
        },
    };
</script>
